export enum PrognosisCostType {
  Fixed = 'Fixed',
  Effect = 'Effect',
  Energy = 'Energy',
  PrivateEnergy = 'PrivateEnergy',
  Addition = 'Addition',
  Bonus = 'Bonus',
  Total = 'Total'
}
